<template>
    <div v-loading="loading">
        <div class="header-btn">
            <el-button type="warning" size="small" icon="el-icon-plus" @click="addForm"></el-button>
        </div>

        <el-table
                class="data-table"
                stripe
                :data="data">
            <el-table-column
                    v-for="item in [
                      {prop:'name',label:'Name'},
                      {prop:'version',label:'Version'},
                      {prop:'updatedDate',label:'Updated Date',fmt:dateFormat},
                      ]"
                    :formatter="item.fmt"
                    :prop="item.prop"
                    :label="item.label"
                    :key="item.label">
            </el-table-column>

            <el-table-column
                    header-align="center"
                    align="center"
                    label="Action">
                <template slot-scope="s">
                    <el-button type="primary" size="mini" icon="el-icon-edit" @click="editForms(s.row)">Edit</el-button>
                    <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteData(s.row.id)">Del</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="page">
            <el-pagination v-if="page.total>1"
                           @current-change="loadData"
                           :page-size="page.size"
                           :current-page.sync="page.page"
                           :page-count="page.totalPage"
                           layout="prev, pager, next"
                           :total="data.total">
            </el-pagination>
        </div>

        <el-dialog
                center
                :close-on-click-modal="false"
                :visible.sync="dialogVisible"
                width="50%">
            <el-form ref="forms" :model="forms" label-position="left" label-width="180px" inline-message>
                <el-form-item label="Name" :required="true" prop="name">
                    <el-input v-model="forms.name" placeholder="Form Name"></el-input>
                </el-form-item>

                <!--<el-form-item label="Property Name" prop="property">-->
                <!--<el-input v-model="forms.propertyName" placeholder="Assign to Property"></el-input>-->
                <!--</el-form-item>-->

                <el-form-item label="Description" prop="description">
                    <el-input v-model="forms.description" placeholder="Form Description" type="textarea" :autosize="{ minRows: 2 }"></el-input>
                </el-form-item>

                <el-form-item label="Terms & Conditions" prop="terms">
                    <div class="item-add-btn">
                        <el-button type="warning" icon="el-icon-plus" size="small" @click="terms.push({})"></el-button>
                    </div>

                    <div v-for="(item,index) in terms" :key="'sn'+index" style="margin-bottom: 5px">
                        <el-input v-model="item.title">
                            <template slot="prepend">term {{index+1}}</template>
                            <el-button slot="append" icon="el-icon-delete" type="danger"
                                       @click="terms.splice(index,1)"></el-button>
                        </el-input>
                        <el-input v-model="item.content" type="textarea" :autosize="{ minRows: 2 }"/>
                    </div>
                </el-form-item>

                <el-form-item label="Remarks" prop="remarks">
                    <el-input v-model="forms.remarks"></el-input>
                </el-form-item>

                <el-form-item label="Soft Copy Form Upload" prop="softCopy">
                    <el-switch v-model="forms.softCopy" :active-value="true" :inactive-value="false"
                               active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                </el-form-item>

                <el-form-item v-if="forms.softCopy">
                    <file-uploader :uploaded-files.sync="files" :multiple="false"></file-uploader>
                </el-form-item>

                <el-form-item label="Allow User Upload Picture" prop="imageRequire">
                    <el-switch v-model="forms.imageRequire" :active-value="true" :inactive-value="false"
                               active-color="#13ce66"
                               inactive-color="#ff4949"></el-switch>
                </el-form-item>

                <el-form-item label="Payment required" prop="paymentRequire">
                    <el-switch v-model="forms.paymentRequire" :active-value="true" :inactive-value="false"
                               active-color="#13ce66"
                               inactive-color="#ff4949"></el-switch>
                </el-form-item>

                <el-form-item label="Pay for" v-show="forms.paymentRequire">
                    <el-input v-model="forms.paymentItems" placeholder="Input the reason for payment"></el-input>
                </el-form-item>

                <el-form-item label="Payment" v-show="forms.paymentRequire">
                    <el-input-number v-model="forms.paymentFee" :min="0"></el-input-number>
                </el-form-item>

                <div class="item-add-btn">
                    <el-button type="warning" icon="el-icon-plus" size="small" @click="filed.push({})"></el-button>
                </div>

                <el-form-item label-width="0" style="margin-top: 1rem">
                    <el-row>
                        <el-col v-for="(item, index) in filed" :key="index">
                            <el-col :span="1">
                                <el-button size="small" type="danger" icon="el-icon-delete"
                                           @click="filed.splice(index, 1)"></el-button>
                            </el-col>

                            <el-col :span="6" :offset="1">
                                <el-input v-model="item.filedName" placeholder="Field Name"></el-input>
                            </el-col>

                            <el-col :span="6" :offset="1">
                                <el-input v-model="item.value" v-if="item.type==='INPUT'" disabled></el-input>
                                <el-input v-model="item.options" type="textarea" v-else
                                          placeholder="Please input options for user choice"></el-input>
                            </el-col>

                            <el-col :span="4" :offset="1">
                                <el-select v-model="item.type" placeholder="Select">
                                    <el-option label="Input" value="INPUT"></el-option>
                                    <el-option label="Options" value="SELECT"></el-option>
                                </el-select>
                            </el-col>

                            <el-col :span="2" :offset="1">
                                <el-checkbox v-model="item.required">Required</el-checkbox>
                            </el-col>
                        </el-col>
                    </el-row>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="success" size="medium" @click="previewDialog =true" icon="el-icon-view">Preview</el-button>
                <el-button type="primary" size="medium" @click="save" icon="el-icon-edit">Save</el-button>
            </span>

            <el-dialog
                    :append-to-body="true"
                    :visible.sync="previewDialog"
                    title="Preview"
                    width="50%">
                <el-form label-width="140px" label-position="right">
                    <div class="container">
                        <el-form-item v-for="(item,index) in filed" :label="item.filedName" :key="'pre'+index"
                                      :required="item.required">
                            <el-input v-if="item.type ==='Input'"></el-input>

                            <!--防止干扰刚才输入的数据所以，item 指向了一个不存在的数据-->
                            <el-select v-else v-model="item.val" placeholder="Check a value" clearable>
                                <el-option
                                        v-for="op in toArray(item.options,'\n')"
                                        :value="op"
                                        :key="'i'+index+op">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="Description">
                            {{forms.description}}
                        </el-form-item>

                        <el-form-item label="Payment items" v-if="forms.paymentRequire">
                            {{forms.paymentItems}}
                        </el-form-item>
                    </div>
                </el-form>

                <div>
                    <div style="width: 100%;text-align: center;font-size: larger;">T&C</div>
                    <el-collapse v-model="forms.active" :accordion="true">
                        <el-collapse-item :title="item.title" :name="item.title" :key="item.title"
                                          v-for="item in terms">
                            {{item.content}}
                        </el-collapse-item>
                    </el-collapse>
                </div>
            </el-dialog>
        </el-dialog>
    </div>
</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
    import {addForm, formType, update, deleteForm} from '@/api/FormAPI'
    import {format} from '../../../utils/Date'
    import FileUploader from '@/components/FileUploader'

    import {s3Url} from '@/utils/Constants'

    export default {
        name: 'FormType',
        components: {FileUploader},
        data: function () {
            return {
                loading: true,
                page: {'page': 1, 'size': 10, 'totalPage': 1, 'total': 0},
                dialogVisible: false,
                filed: [],
                files: [],
                terms: [],
                data: [],
                forms: {},
                previewDialog: false,
                uploadUrl: ''
            }
        },
        methods: {
            editForms(data) {
                this.forms = data
                this.filed = JSON.parse(data.templates)
                this.terms = JSON.parse(data.terms)
                this.filed.forEach((item) => {
                    if (item.type === 'SELECT' && item.options instanceof Array) {
                        item.options = item.options.join("\n")
                    } else {
                        item.options = []
                    }
                })
                this.files = []
                if (this.forms.file) {
                    this.files.push(this.forms.file)
                }
                this.dialogVisible = true;
            },
            deleteData(id) {
                this.$deleteRequest(this, deleteForm, id)
            },
            addForm() {
                this.filed = []
                this.forms = {}
                this.terms = []
                this.files = []
                this.dialogVisible = true
            },
            loadData() {
                this.$pageUtils(this, formType)
                this.dialogVisible = false
            },
            save() {
                const data = this.$copy(this.forms)
                let tempFiled = JSON.parse(JSON.stringify(this.filed))
                tempFiled.forEach((item) => {
                    if (item.type === 'SELECT') {
                        item.options = item.options.split("\n")
                    }
                })
                if (!data.status) {
                    data.status = 1
                }
                data.file = this.files[0]
                data.templates = JSON.stringify(tempFiled)
                data.terms = JSON.stringify(this.terms)
                const action = data.id ? update : addForm

                action(data).then(() => {
                    this.dialogVisible = false
                    this.loadData()
                })
            },
            dateFormat(row, col, cell) {
                return format(cell)
            }
        },
        mounted() {
            this.uploadUrl = s3Url
            this.loadData()
        }
    }
</script>

<style scoped>
    .el-button{
        margin-right: 5px;
    }

    .item-add-btn {
        width: 100%;
        text-align: right;
    }

    .el-col {
        margin-bottom: 5px;
    }

    .container {
        text-align: center;
    }
</style>
